<div class="container-flow bg-color">
    <div class="row">
        <div class="col-12 text-center">
            <img class="not-found-image" src="assets/img/not-found/not-found.jpg" alt="notFound">
        </div>
    </div>
</div>